import React, { useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next"; /* Added Line */
import Spinner from 'react-bootstrap/Spinner';
import { ThemeContext } from "../../../context/ThemeContext";



export default function CrudMain(props) {
  const [t, i18n] = useTranslation(); /* Added Line */
  const { spinner } = useContext(ThemeContext);

  return (
    <>
      {!props.hideNewAddButton && (
        <Button
          className="pull-right btn-sm"
          variant="primary"
          onClick={() => props.onAddButtonClicked()}
        >
          <span
            className="btn-icon-left text-primary"
            style={{
              margin: "-0.3rem 0.2rem -0.3rem -0.7rem",
            }}
          >
            <i
              className={
                "fa fa-" +
                (props.customAddButtonTitle == t("actionButtonGenerator.guncelle") ? "edit" : "plus") +
                " color-primary"
              }
            />
          </span>
          {props.customAddButtonTitle || `${t("demandCreate.ekle")}`}
        </Button>
      )}
      {props.showBackButton && (
        <Button
          className="btn-sm"
          variant="primary"
          onClick={() => props.onBackButton()}
        >
          <span
            className="btn-icon-left color-primary"
            style={{
              margin: "-0.3rem 0.2rem -0.3rem -0.7rem",
            }}
          >
            <i className="fa fa-arrow-left" />
          </span>
          {t("userRole.back")}
        </Button>
      )}
      <Modal
        className="modal fade"
        size={props.size || "md"}
        show={props.showModal}
        scrollable={!props.unscrollable}
        style={{overflow: 'visible'}}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{props.title}</h5>
            {spinner && <Spinner className={"service-loader"} animation="border" />}
            <Button
              variant=""
              type="button"
              className="close"
              data-dismiss="modal"
              onClick={() => {
                if(props.closeModal){
                  props.closeModal();
                }
                props.setShowModal(false);
                if (props.setInitialValues) {
                    props.setInitialValues({});
                }
              }}
            >
              <span>×</span>
            </Button>
          </div>
          <div className="modal-body">{props.children}</div>
        </div>
      </Modal>
    </>
  );
}
